<template>
    <div style="width:100%;heigh:100%;" id="technology-conf">
        <div class="table_searchbar">
            <el-row :gutter="W?20:0">
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">模板名称：</span>
                    <el-input size="small" style="max-width:180px" v-model="searchForm.technologyTemplateName"  maxlength="50" placeholder="模板名称"></el-input>
                    </div>
                </el-col>
                <el-col :span="span">
                    <div class="">
                        <span class="title">物料类型：</span>
                        <el-select   size="small" placeholder="物料类型"  style="max-width:180px" v-model="searchForm.type" >
                            <el-option key="0" label="产品" value="0"></el-option>
                                <el-option key="1" label="零件" value="1"></el-option>
                        </el-select>            
                    </div>
                </el-col>
                <el-col :span="W?span:6">
                    <div class="">
                        <span class="title">创建日期：</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd" style="max-width:180px" v-model="searchForm.gmtCreate" type="date" format="yyyy-MM-dd" placeholder="创建日期" ></el-date-picker>               
                    </div>
                </el-col>
                <el-col :span="W?(24-3*span):4">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="table_common_operbar">
            <el-row>
                <el-button icon="el-icon-plus" type="primary" size="small" v-if="permission.btn_technologyTemplate_add" @click="addWindowShow()">新增模板</el-button>
            </el-row>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" class="deviceTable" >
            <el-table-column prop="technologyTemplateName" label="模板名称" min-width="160"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="deviceTypeId" label="工艺图纸"  min-width="110">
                <template slot-scope="scope">
                    <div v-if="scope.row.technologyDrawing&&scope.row.fileName" style="width:42px;height:42px;">
                        <el-tooltip class="item" effect="dark" :content="scope.row.fileName" placement="bottom-end">
                            <div class="file-icon-container" :style="{'backgroundImage':`url(${scope.row.filePath})`,top:`-6px`}" @click="showFile(scope.row.technologyDrawingUrl)">
                            </div>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="工序数量"  min-width="110">
                <template slot-scope="scope">
                    {{scope.row.procedureFlowList&&scope.row.procedureFlowList.length}}
                </template>
            </el-table-column>
            <el-table-column prop="type" label="物料类型" :formatter='parseType' ></el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间"  ></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                    <el-button type="text" @click="showEditDialog(scope.row)" v-if="permission.btn_technologyTemplate_update" size="small">编辑</el-button>
                    <el-button type="text" @click="deleteConfig(scope.row)" v-if="permission.btn_technologyTemplate_delete" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                </el-pagination>
            </div>
        </div>

        <!-- 新增开始 -->
        <el-dialog title="新增工艺模板" @close="cancelAddDialog"   :visible.sync="addDialogVisible" :width="span==5?'60%':'74%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="8">
                        <span class="title">模板名称：</span>
                        <el-form-item prop="technologyTemplateName" class="value" :rules="rules.configName">
                            <el-input size="small" style="max-width:180px" ref="focusinput" v-model="addForm.technologyTemplateName" maxlength="50" placeholder="模板名称" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">物料类型：</span>
                        <el-form-item prop="type" class="value" :rules="rules.type">
                            <el-select   size="small" placeholder="物料类型"  style="max-width:180px" v-model="addForm.type" >
                                <el-option key="0" label="产品" :value="0"></el-option>
                                    <el-option key="1" label="零件" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="height: 58px;overflow: hidden;padding-top: 12px;margin-top: -10px;">
                        <span class="titel">工艺图纸：</span>
                        <el-form-item  class="value" >
                            <div v-if="addForm.technologyDrawing" >
                                <div style="width:42px;height:42px;">
                                    <el-tooltip class="item" effect="dark" :content="addForm.fileName" placement="bottom-end">
                                        <div class="file-icon-container" :style="{'backgroundImage':`url(${addForm.technologyDrawingPath})`,top:`-6px`}" @click="showFile(addForm.technologyDrawingUrl)">
                                            <div class="file-delete" @click.stop="deleteFile(-1,1)"></div>
                                             &nbsp;
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div v-else style="margin-top:-5px;width:40px;height:40px;border:dotted #409eff 1px;text-align:center" @click="selectUploadFile(-1,0)" >
                                <!-- <el-upload :action="uploadUrl(1,-1)" :before-upload='beforeUpload' :on-success="uploadComplete"> -->
                                    <i class="el-icon-plus" style="width:40px;height:40px;margin-top: 12px;" ></i>
                                <!-- </el-upload> -->
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" >
                    <el-col :span="24">
                        <el-button type="primary" size="medium" @click="addDetailList()">新增工序</el-button>
                    </el-col>
                </el-row>
                <el-table :data="procedureData" Height ='457'   style="width: 100%;margin-bottom:10px; overflow-y: auto;max-height:457px"  >
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            <el-form-item>
                                <span>{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序编号" min-width="100">
                        <template slot-scope="scope"> 
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].procedureCode`" >
                                <el-input :ref="`focusprocedure${scope.$index}`" size="small" maxlength="16" v-model="procedureData[scope.$index].procedureCode"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序名称" min-width="100">
                        <template slot-scope="scope"> 
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].procedureName`" :rules="rules.procedureName">
                                <el-input  size="small" maxlength="16" v-model="procedureData[scope.$index].procedureName"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="设备类型" min-width="130" >
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.deviceTypeId" >
                                <el-select size="small" v-model="procedureData[scope.$index].deviceType" placeholder="设备类型" clearable  style="width:120px;display:block">
                                    <el-option v-for="item in deviceType" :key="item.id" :label="item.deviceType" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="加工节拍(秒)" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].productionCycle`" :rules="rules.productionCycle">
                                <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].productionCycle"></el-input>
                           </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="换型时间(小时)" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].prepareTime`" :rules="rules.prepareTime">
                                <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].prepareTime"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="每件薪资(元)" min-width="100"  >
                        <template slot-scope="scope" >
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].everySalary`" :rules="rules.everySalary">
                                <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].everySalary"></el-input>
                           </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序图纸" min-width="80">
                        <template slot-scope="scope">
                            <div v-if="procedureData[scope.$index].procedureDrawing != null" >
                                <div style="width:80px;height:70px;padding-top: 10px;">
                                    <el-tooltip class="item"  effect="dark" :content="procedureData[scope.$index].fileName" placement="bottom-end">
                                        <div class="file-icon-container" :style="{'backgroundImage':`url(${procedureData[scope.$index].procedureDrawingPath})`}" @click="showFile(procedureData[scope.$index].procedureDrawingUrl)">
                                            <div class="file-delete" @click.stop="deleteFile(scope.$index,1)"></div>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div v-else style="width:40px;height:40px;border:dotted #409eff 1px;text-align:center" @click="selectUploadFile(scope.$index,0)" >
                                <!-- <el-upload :action="uploadUrl(1)" :before-upload='beforeUpload' :on-success="uploadComplete" > -->
                                    <i class="el-icon-plus" style="width:40px;height:40px;margin-top: 12px;" ></i>
                                <!-- </el-upload> -->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="质检模板" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item>
                                 <el-select size="small" clearable  v-model="procedureData[scope.$index].qcTemplateId" placeholder="质检模板" style="display:block">
                                    <el-option v-for="item in templateList" :key="item.id" :label="item.templateName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column> 
                    <el-table-column label="扫码确认" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-checkbox v-model="procedureData[scope.$index].needScanCode" ></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column> 
                    <el-table-column label="其他" min-width="140">
                        <template slot-scope="scope">
                            <el-form-item>
                            <el-input size="small" v-model="procedureData[scope.$index].remark" maxlength="254"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column> 
                    <el-table-column label="操作"  width="50">
                        <template slot-scope="scope">
                            <el-form-item>
                            <div class="delete"   type="primary"  @click="removeDetail(scope.$index)"></div>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddDialog">添 加</el-button>
                <el-button @click="cancelAddDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新增结束 -->

         <!-- 编辑开始 -->
        <el-dialog title="编辑模板配置" @close="cancelEditDialog"  :visible.sync="editDialogVisible" :width="span==5?'60%':'74%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="8">
                        <span class="title">模板名称：</span>
                        <el-form-item prop="technologyTemplateName" class="value" :rules="rules.configName">
                            <el-input size="small" style="max-width:180px" v-model="addForm.technologyTemplateName" maxlength="50" placeholder="点检名称" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">物料类型：</span>
                        <el-form-item prop="type" class="value" :rules="rules.type">
                            <el-select   size="small" placeholder="物料类型"  style="max-width:180px" v-model="addForm.type" >
                                <el-option key="0" label="产品" :value="0"></el-option>
                                    <el-option key="1" label="零件" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="height: 58px;overflow: hidden;padding-top: 12px;margin-top: -10px;">
                        <span class="titel">工艺图纸：</span>
                        <el-form-item  class="value" >
                            <div v-if="addForm.technologyDrawingUrl" >
                                <div style="width:42px;height:42px;">
                                    <el-tooltip class="item" effect="dark" :content="addForm.fileName" placement="bottom-end">
                                        <div class="file-icon-container" :style="{'backgroundImage':`url(${addForm.technologyDrawingPath})`,top:`-6px`}" @click="showFile(addForm.technologyDrawingUrl)">
                                            <div class="file-delete" @click.stop="deleteFile(-1,1)"></div>
                                             &nbsp;
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div v-else style="margin-top:-5px;width:40px;height:40px;border:dotted #409eff 1px;text-align:center" @click="selectUploadFile(-1,0)" >
                                <!-- <el-upload :action="uploadUrl(1,-1)" :before-upload='beforeUpload' :on-success="uploadComplete"> -->
                                    <i class="el-icon-plus" style="width:40px;height:40px;margin-top: 12px;" ></i>
                                <!-- </el-upload> -->
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" >
                    <el-col :span="24">
                        <el-button type="primary" size="medium" @click="addDetailList()">新增工序</el-button>
                    </el-col>
                </el-row>
                <el-table :data="procedureData" Height ='457'   style="width: 100%;margin-bottom:10px; overflow-y: auto;max-height:457px"  >
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            <el-form-item>
                                <span>{{scope.$index+1}}</span>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序编号" min-width="100">
                        <template slot-scope="scope"> 
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].procedureCode`" >
                                <el-input :ref="`focusprocedure${scope.$index}`" size="small" maxlength="16" v-model="procedureData[scope.$index].procedureCode"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序名称" min-width="100">
                        <template slot-scope="scope"> 
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].procedureName`" :rules="rules.procedureName">
                                <el-input  size="small" maxlength="16" v-model="procedureData[scope.$index].procedureName"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="设备类型" min-width="130" >
                        <template slot-scope="scope">
                            <el-form-item  :rules="rules.deviceTypeId">
                                <el-select size="small" v-model="procedureData[scope.$index].deviceType" placeholder="设备类型" clearable  style="width:120px;display:block">
                                    <el-option v-for="item in deviceType" :key="item.id" :label="item.deviceType" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="加工节拍(秒)" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].productionCycle`" :rules="rules.productionCycle">
                                <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].productionCycle"></el-input>
                           </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="换型时间(小时)" min-width="100">
                        <template slot-scope="scope">
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].prepareTime`" :rules="rules.prepareTime">
                            <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].prepareTime"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="每件薪资(元)" min-width="100"  >
                        <template slot-scope="scope" >
                            <el-form-item :prop="`procedureFlowList[${scope.$index}].everySalary`" :rules="rules.everySalary">
                                <el-input size="small" maxlength="16" v-model="procedureData[scope.$index].everySalary"></el-input>
                           </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序图纸" min-width="80">
                        <template slot-scope="scope">
                            <div v-if="procedureData[scope.$index].procedureDrawingUrl != null" >
                                <div style="width:80px;height:70px;padding-top: 10px;">
                                    <el-tooltip class="item"  effect="dark" :content="procedureData[scope.$index].fileName" placement="bottom-end">
                                        <div class="file-icon-container" :style="{'backgroundImage':`url(${procedureData[scope.$index].procedureDrawingPath})`}" @click="showFile(procedureData[scope.$index].procedureDrawingUrl)">
                                            <div class="file-delete" @click.stop="deleteFile(scope.$index,1)"></div>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div v-else style="width:40px;height:40px;border:dotted #409eff 1px;text-align:center" @click="selectUploadFile(scope.$index,0)" >
                                <!-- <el-upload :action="uploadUrl(1)" :before-upload='beforeUpload' :on-success="uploadComplete" > -->
                                    <i class="el-icon-plus" style="width:40px;height:40px;margin-top: 12px;" ></i>
                                <!-- </el-upload> -->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="质检模板" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item>
                                 <el-select size="small" clearable v-model="procedureData[scope.$index].qcTemplateId" placeholder="质检模板" style="display:block">
                                    <el-option v-for="item in templateList" :key="item.id" :label="item.templateName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column> 
                    <el-table-column label="扫码确认" min-width="80">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-checkbox v-model="procedureData[scope.$index].needScanCode" ></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="其他" min-width="140">
                        <template slot-scope="scope">
                            <el-form-item>
                                <el-input size="small" v-model="procedureData[scope.$index].remark" maxlength="254"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column> 
                    <el-table-column label="操作"  width="50">
                        <template slot-scope="scope">
                            <el-form-item>
                            <div class="delete"   type="primary"  @click="removeDetail(scope.$index)"></div>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitEditDialog">保 存</el-button>
                <el-button @click="cancelEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑结束 -->

        <!-- 查看开始 -->
        <el-dialog title="查看模板配置" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'58%':'74%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:30px">
                    <el-col :span="8">
                        <span class="title">模板名称：</span>
                        <span>{{addForm.technologyTemplateName}}</span> 
                    </el-col>
                     <el-col :span="8">
                        <span class="title">物料类型：</span>
                        <span>{{addForm.typeText}}</span> 
                    </el-col>
                    <el-col :span="8">
                        <span class="title" style="display: inline-block;">工艺图纸：</span>
                        <div style="width:42px;height:42px;display: inline-block;">
                            <el-tooltip class="item" effect="dark" :content="addForm.fileName" placement="bottom-end"  v-if="addForm.technologyDrawingUrl">
                                <div class="file-icon-container" :style="{'backgroundImage':`url(${addForm.technologyDrawingPath})`,top:`-12px`}" @click="showFile(addForm.technologyDrawingUrl)">
                                        &nbsp;
                                </div>
                            </el-tooltip>
                            <div v-else>
                                &nbsp; 
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-table :data="procedureData" Height ='457'   style="width: 100%;margin-bottom:10px; overflow-y: auto;max-height:457px"  >
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="procedureCode" label="工序编号" min-width="100"></el-table-column>
                    <el-table-column prop="procedureName" label="工序名称" min-width="100"></el-table-column>
                    <el-table-column prop="deviceType" label="设备类型" :formatter='parseDeviceType' min-width="100" ></el-table-column>
                    <el-table-column prop="productionCycle" label="加工节拍(秒)" min-width="90"></el-table-column>
                    <el-table-column prop="prepareTime" label="换型时间(小时)" min-width="90"></el-table-column>
                    <el-table-column prop="everySalary" label="每件薪资(元)" min-width="90"></el-table-column>
                    <el-table-column label="工序图纸" min-width="80">
                        <template slot-scope="scope">
                            <div v-if="procedureData[scope.$index].procedureDrawing != null" >
                                <div style="width:80px;height:70px;padding-top: 10px;">
                                    <el-tooltip class="item"  effect="dark" :content="procedureData[scope.$index].fileName" placement="bottom-end">
                                        <div class="file-icon-container" :style="{'backgroundImage':`url(${procedureData[scope.$index].procedureDrawingPath})`}" @click="showFile(procedureData[scope.$index].procedureDrawingUrl)">
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qcTemplateName" label="质检模板" min-width="90"></el-table-column>
                    <el-table-column prop="remark" label="其他" min-width="140" ></el-table-column> 
                    <el-table-column label="扫码确认" min-width="80">
                        <template slot-scope="scope">
                            <span><el-checkbox label="" disabled v-model="scope.row.needScanCode"></el-checkbox></span>
                        </template>
                    </el-table-column>
                </el-table>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyTemplate" type="primary">复制模板</el-button>
                <el-button @click="cancelViewDialog" >关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 查看结束 --> 

        <FileView  ref="fileView"/>
    </div>
</template>

<script>
import CommonUtils from '../util/CommonUtils';
import FileView from '../components/common/FileView.vue'

export default {
    name: 'TechnologyConfig',
    components:{
        FileView
    },
	data () {
        return {
            fristLoad:false,
            templateList:[],
            currentFileType:null,
            index:null,
            procedureData:[],
            deviceType:[],
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                technologyTemplateName:null,
                gmtCreate:null,
                type:null
            },
            addForm:{
                technologyDrawing:null,
                procedureData:[
                ],
                procedureFlowList:[]
            },
            tableData:[],
            tableCurrentPage:1,
            tableTotalPage:2,
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            rules:{
                configName:[
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
                type:[
                    { required: true, message: '请选择物料类型', trigger: 'blur' }
                ],
                procedureName:[
                    { required: true, message: '请输入工序名称', trigger: 'blur' }
                ],
                deviceTypeId:[
                    {required: true, message: '请选择设备类型', trigger: 'blur'}
                ],
                prepareTime:[
                    {validator(rule, value, callback) {
                            if(value){
                                let num = Number(value)
                                if(isNaN(num)){
                                    callback(new Error('时间为数字'))
                                }else{
                                    if(num<0){
                                        callback(new Error('时间大于零'))
                                    }else{
                                        if(Number.isInteger(num)){
                                           if(num>99){
                                               callback(new Error('时间最多2位'))
                                           }else{
                                               callback()
                                           }
                                        }else{
                                            callback(new Error('时间为正整数'))
                                        }
                                    }
                                    
                                }
                            }else{
                                callback()
                            }
                    }}
                ],
                productionCycle:[
                     {validator(rule, value, callback) {
                            if(value){
                                let num = Number(value)
                                if(isNaN(num)){
                                    callback(new Error('节拍必须为数字'))
                                }else{
                                    if(num<0){
                                        callback(new Error('节拍必须大于零'))
                                    }else{
                                        if(!(/^\d+(\.\d{1,5})?$/.test(num))){
                                            callback(new Error('节拍最多保留5位小数'))
                                        }else if(num>99999.99999){
                                            callback(new Error('节拍最多保留5位整数'))
                                        }else{
                                            callback()
                                        }
                                    }
                                    
                                }
                            }else{
                                callback()
                            }
                     }}
                ],
                everySalary:[
                    {validator(rule, value, callback) {
                            if(value){
                                log('value',value)
                                let num = Number(value)
                                if(isNaN(num)){
                                    callback(new Error('薪资必须为数字'))
                                }else{
                                    if(num<0){
                                        callback(new Error('薪资必须大于零'))
                                    }else{
                                        if(!(/^\d+(\.\d{1,4})?$/.test(num))){
                                            callback(new Error('薪资最多保留4位小数'))
                                        }else if(num>999999.9999){
                                            callback(new Error('薪资不能超过6位整数'))
                                        }else{
                                        callback()  
                                        }
                                    }
                                }
                            }else{
                                callback()
                            }
                        }
                    }
                ],
            },
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted:function(){
        this.initTable();
        this.loadTemplateList()
        this.addForm.procedureData = this.procedureData
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.loadDeviceTypeList()
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        copyTemplate(){
            //1.获取需要添加的模板数据
              this.$set(this.addForm,'technologyTemplateName','')
              this.addForm.technologyDrawing = null
            //2.将数据渲染到新增页面
            this.addWindowShow()
            this.viewDialogVisible = false
        },
        async loadDeviceTypeList(){
            let {data,code,msg,message}=await this.$RequestUtil.getAsync({ url: '/api/device/listDeviceType', type:'sync', params: {},})
            if(code==0){
                this.deviceType = data
            }else{
                this.$message.error(msg||message)
            }
        },
        reload(){
            this.initTable();
            this.loadTemplateList()
            this.loadDeviceTypeList()
            this.$store.commit('delete_reloadPages','/TechnologyConfig')
            this.$forceUpdate()
        },
        loadTemplateList(){
            this.$RequestUtil.get({
                url: '/api/select/listQcTemplates',
                type:'sync',
                params: {},
                success: (res) => {
                    if(res.code != -1){
                        this.templateList = res.data
                    }
                }
            })
        },
        deleteFile:function(index,type){
            if(!this.permission.btn_file_upload){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件删除权限`
                })
                return false
             }
            this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(index==-1){
                    this.addForm.technologyDrawing = null
                    this.addForm.technologyDrawingUrl = null
                }else{
                    this.procedureData[index].procedureDrawing = null
                    this.procedureData[index].procedureDrawingUrl = null
                }
            });
        },
        uploadUrl:function(fileType,index){
            let res = "/api/file/upload?token="+localStorage.getItem("token")+"&fileType="+fileType
            return res
        },
        beforeUpload(file){
            if(!this.permission.btn_file_upload){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件上传权限`
                })
                return false
             }
            let fileSize = file.size/1024/1024
             fileSize = Math.round(fileSize*100)/100
            if(fileSize>=10){
                this.$message({
                    type:'error',
                    message:`文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
                })
                 return false
            }
            this.$RequestUtil.loading().close()
        },
        getFilePath(fileName){
            if(!fileName){
                return
            }
            let filePath = ''
            let arr = fileName.split('.')
            let suffix = arr[arr.length-1]
            switch(true){
                case suffix == 'pdf'||suffix=='pptx':
                    filePath = '../../static/img/pdf.png'
                    break
                case suffix == 'png'|| suffix == 'jpg' || suffix == 'svg':
                   filePath = '../../static/img/pic.png'
                   break
                case suffix == 'txt'||suffix=='doc'||suffix=='docx':
                    filePath = '../../static/img/txt.png'
                    break

                default:
                  filePath = '../../static/img/file.png'
            }
            return filePath

        },
        uploadComplete:function(response, file, fileList) {
            this.$RequestUtil.loading().close()
            if(response != null&&response.data){
                if(this.index==-1){
                    this.$set(this.addForm,'technologyDrawing',response.data.id)
                    this.$set(this.addForm,'fileName',response.data.fileName)
                    this.$set(this.addForm,'technologyDrawingUrl',response.data.url)
                    this.$set(this.addForm,'technologyDrawingPath',this.getFilePath(response.data.fileName))
                }else{    
                    this.$set(this.procedureData[this.index],'procedureDrawing',response.data.id)
                    this.$set(this.procedureData[this.index],'fileName',response.data.fileName)
                    this.$set(this.procedureData[this.index],'procedureDrawingUrl',response.data.url)
                    this.$set(this.procedureData[this.index],'procedureDrawingPath',this.getFilePath(response.data.fileName))
               }
            }
        },
        selectUploadFile:function(index,fileType){
            if(!this.permission.btn_fileSys_list){
                this.$message.warning('您暂无文件管理权限')
                return
            }
            this.$refs.fileView.initView(null,fileType)
            this.index = index;
            this.currentFileType = fileType;
        },
        showFile:function(url){
            log(url)
            if(!this.permission.btn_file_get){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件读取权限`
                })
                return false
             }
            if(!url){
                this.$message.warning('当前文件不存在')
                return
            }
            let index = url.lastIndexOf(".");
            let ext = url.substr(index+1).toLowerCase();
            //可直接被浏览器打开的文件类型
            let arr = ['pdf','png','jpg','svg','txt','html','js','art','au','aiff','xbf','jpeg']        
            if(arr.includes(ext)){
                window.open(url,'_blank');
            }else{
                window.location.href = url;
            }
        },
        deleteConfig(rowData){
            this.$confirm('此操作将删除该工艺模板, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/technologyTemplate/deleteTemplate',
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(1);
                        }
                    }
                })
            })
        },
        parseDeviceType(rowData){
            let num = Number(rowData.deviceType)
            let str = ''
            this.deviceType.forEach(item=>{
                if(item.id==num){
                    str = item.deviceType
                }
            })
            return str
        },
        parseType(rowData){
            if(rowData.type==0){
                return '产品'
            }else if(rowData.type==1){
                return '零件'
            }else if(rowData.materialType == 2){
                return '原材料'
            }
        },
        cancelEditDialog(){
            this.$refs['editForm'].resetFields()
            this.editDialogVisible = false
            this.addForm.technologyTemplateName=''
            this.addForm.technologyDrawing=null
            this.addForm.type=null
            this.addForm.procedureData=[]
            this.procedureData = []
        },
        cancelViewDialog(){
            this.viewDialogVisible = false
            // this.addForm.technologyTemplateName= ''
            // this.addForm.technologyDrawing=null
            // this.addForm.type=null
            // this.addForm.procedureData=[]
            // this.procedureData = []
        },
        removeDetail(rowIndex){
            this.procedureData.splice(rowIndex, 1);
        },
        addDetailList(){
            let index = this.procedureData.length

            this.procedureData.push({})
            setTimeout(()=>{
                log(this.$refs[`focusprocedure${index}`])
                 this.$refs[`focusprocedure${index}`].focus()
            },0)
             this.addForm.procedureFlowList = this.procedureData

        },
        cancelAddDialog(){
            this.$refs['addForm'].resetFields()
            this.addDialogVisible = false
            this.addForm.technologyTemplateName=''
            this.addForm.technologyDrawing=null,
            this.addForm.type=null
            this.addForm.procedureData=[]
            this.procedureData = []
        },
        submitAddDialog(){
            this.$refs['addForm'].validate((valid) => {
                if(valid){
                    if(this.procedureData.length==0){
                        this.$message.warning('工序配置项不能为空')
                        return
                    }
                    let isPass = true
                    let errTitle = ''
                    this.procedureData.forEach((item,i)=>{
                        item.index=(i+1)*10
                    })
                    this.addForm.procedureFlowList = this.procedureData
                    this.$RequestUtil.post({
                        url: '/api/technologyTemplate/addTemplate',
                        type:'sync',
                        params: this.addForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.$message.success('添加成功')
                                this.initTable();
                                this.cancelAddDialog()
                            }else{
                                this.$message.error(res.message);
                            }
                        },
                    })
                    
                }
                log(this.addForm)
                console.log('提交',valid)
            })
        },
        submitEditDialog(){
             this.$refs['editForm'].validate((valid) => {
                if(valid){
                     if(this.procedureData.length==0){
                        this.$message.warning('工序配置项不能为空')
                        return
                    }
                    this.addForm.procedureData = this.procedureData
                    this.$RequestUtil.post({
                        url: '/api/technologyTemplate/updateTemplate',
                        type:'sync',
                        params: this.addForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.$message.success('编辑成功')
                                this.initTable();
                                this.cancelEditDialog()
                            }else{
                                this.$message.error(res.message);
                            }
                        },
                    })  
                }
                log(this.addForm)
                console.log('提交',valid)
            })
        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.technologyTemplateName=null
            form.gmtCreate=null
            form.type = null
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    technologyTemplateName:null,
                    gmtCreate:null,
                    type:null
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/technologyTemplate/listTemplateMsg',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    technologyTemplateName:temp.technologyTemplateName,
                    gmtCreate:temp.gmtCreate,
                    type:temp.type
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        res.data.forEach(item=>{
                            if(item.technologyDrawing&&item.fileName){
                                item.filePath = this.getFilePath(item.fileName)
                            }
                        })
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                         this.$message.error(res.message||res.msg)
                    }
                    
                }
            }); 
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        addWindowShow:function(){
            this.addDialogVisible = true;
            setTimeout(()=>{
                this.$refs.focusinput.focus()
            },0)
        },
        showEditDialog:function(rowData){
            this.addForm = CommonUtils.cloneObj((rowData))
            if(this.addForm.fileName){
                this.addForm.technologyDrawingPath = this.getFilePath(this.addForm.fileName)
            }
            this.addForm.procedureFlowList.forEach((item,i)=>{
                if(item.fileName){
                    item.procedureDrawingPath = this.getFilePath(item.fileName)
                }
            })
            this.procedureData=this.addForm.procedureFlowList
            this.editDialogVisible = true;
        },
        showViewDialog(rowData){
            this.addForm = CommonUtils.cloneObj((rowData))
            if(this.addForm.fileName){
                this.addForm.technologyDrawingPath = this.getFilePath(this.addForm.fileName)
            }
            this.addForm.procedureFlowList.forEach((item,i)=>{
                if(item.fileName){
                    item.procedureDrawingPath = this.getFilePath(item.fileName)
                }
            })
            this.procedureData=this.addForm.procedureFlowList
            this.viewDialogVisible = true;
            this.addForm.typeText = this.parseType(rowData)
            log(this.addForm)
        },
        viewDevice:function(rowData){
            this.viewDialogVisible = true;
        },
        parseDate:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString;
            }
        }
    }
}
</script>

<style scoped>
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover{

    background-image: url('../../static/img/del-hover.png');
    background-repeat: no-repeat;
}
.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.add_form .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 70px;
}
.add_form .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
.file-icon-container{
    width:36px;
    height:45px;
    margin-top:0px;

    background-size: cover;
    position:relative;
    cursor:pointer;
}
.file-delete{
    position:absolute;
    top:-6px;
    left:28px;
    width:15px;
    height:15px;
    background-image:URL('../../static/img/delete.png');
    background-size: cover;
    cursor:pointer;
}
</style>
<style>
#technology-conf .el-form-item--mini.el-form-item,#technology-conf .el-form-item--small.el-form-item{
    margin-top: 8px;
    margin-bottom: 13px;
}
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.el-textarea .el-input__count{
    line-height: 12px;
}
@media screen and (max-width: 1366px) {
    #technology-conf .el-input{
        width: auto
    }
    #technology-conf .el-table__fixed-right {
        height: 500px !important;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/TechnologyConfig.vue